import { animate, style, transition, trigger } from '@angular/animations';
import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
} from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { ThemeManagementFeature } from '@qtek/core/theme-management';
import { CoreStore } from '@qtek/libs/store';
import { EMPTY, Observable, timer } from 'rxjs';
import { debounce, debounceTime, map } from 'rxjs/operators';

@Component({
  selector: 'qt-loader',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe],
  template: `
    @if (display | async) {
      <div @fadeInOut class="container">
        <img
          id="synply-loader"
          class="synply-loader"
          src="/assets/img/new-logo_anim.svg"
          height="150"
          width="150" />
      </div>
    }
  `,
  styles: [
    `
      .container {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: var(--app-main-background);
        z-index: 10;
      }
    `,
  ],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('0.3s', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('0.5s', style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class LoaderComponent {
  private store = inject(Store);
  private coreStore = inject(CoreStore);
  private element = inject(ElementRef);

  display: Observable<boolean> = toObservable(
    this.coreStore.displayLoading
  ).pipe(debounceTime(0));
  animation: Observable<boolean> = toObservable(
    this.coreStore.animationLoading
  ).pipe(debounce(val => (!val ? timer(500) : EMPTY)));
  constructor() {
    this.store
      .select(ThemeManagementFeature.selectUiTheme)
      .pipe(map(theme => theme === 'dark'))
      .subscribe(isDarkTheme => {
        if (isDarkTheme) {
          this.element.nativeElement.classList.add('darkTheme');
        } else {
          this.element.nativeElement.classList.remove('darkTheme');
        }
      });
  }
}
